import React from 'react';
import ContentLinkRenderer from "../ContentLinkRenderer/ContentLinkRenderer";
import PropTypes from 'prop-types';

const pressReleaseWidget = (props) => {
  return (
    <ul className="unstyled-list basic-two-columns__feed-list">
      {
        props.pressReleases
          .filter((item, index) => {
            return index < (props.displayAmount ? props.displayAmount : 5)
          })
          .map((item, index) => {
            return (
              <li key={index} className="basic-two-columns__feed-item">
                <ContentLinkRenderer
                  contentType={item.detailContent.type}
                  value={item.detailContent.value}
                  linkContent={item.title}
                  className={`basic-two-columns__feed-link ${props.linkColorClass ? props.linkColorClass : ''}`}
                  target={item.detailContent.target}
                  pathForItem="/about/press-releases/press-release"
                  id={item.id}
                  onEmptyContent={<p className="basic-two-columns__text color-white mtn">{item.title}</p>}
                />
              </li>
            )
          })
      }
    </ul>
  )
};

export default pressReleaseWidget;

pressReleaseWidget.propTypes = {
  pressReleases: PropTypes.any,
  linkColorClass: PropTypes.string,
  displayAmount: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/components/PressReleaseWidget/PressReleaseWidget.js